import styled from 'styled-components'
import { Style } from '../../styles'

const ConversationAnnouncement = styled.div`
	color: rgb(171, 174, 190);
	padding: ${Style.spacing.x2} ${Style.spacing.x1};
	text-align: center;
`

export default ConversationAnnouncement